import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import { ScanFace } from "lucide-react";

const LOGO_URL = "https://customer-assets-4nw71qhi.emergentagent.net/job_academia-control-3/artifacts/hiofilsr_LOGO%20AMERICANFIT.png";

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Bem-vindo!");
      navigate(u?.role === "admin" ? "/" : "/mural");
    } catch (err) {
      console.error("login error", err);
      toast.error(err.response?.data?.detail || (err.response ? `Erro no login (${err.response.status})` : "Sem conexão com o servidor. Verifique a internet e tente de novo."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-white">
      <div className="hidden lg:flex relative bg-black text-white p-12 flex-col justify-center items-center overflow-hidden">
        <div className="relative z-10 flex flex-col items-center w-full">
          <img src={LOGO_URL} alt="American Fit" className="w-full max-w-3xl drop-shadow-2xl" />
          <p className="mt-10 text-slate-300 text-lg text-center">
            Sistema de gestão biométrica com reconhecimento facial, IA e multiunidade.
          </p>
          <div className="mt-6 flex items-center gap-2 text-sm text-rose-400">
            <ScanFace className="w-4 h-4"/> Catraca facial · Treinos IA · Pix · Multiunidade
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center p-8 bg-white">
        <Card className="w-full max-w-md p-8 border border-slate-200 shadow-lg">
          <div className="flex lg:hidden justify-center mb-6">
            <img src={LOGO_URL} alt="American Fit" className="h-24 bg-black rounded-2xl p-3"/>
          </div>
          <div className="mb-8">
            <h2 className="font-heading text-3xl font-bold text-slate-900">Acessar sistema</h2>
            <p className="text-slate-500 mt-2">Entre com sua conta corporativa</p>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email-input" required className="mt-1" />
            </div>
            <div>
              <Label htmlFor="password">Senha</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password-input" required className="mt-1" />
            </div>
            <Button type="submit" disabled={loading}
              data-testid="login-submit-button"
              className="w-full bg-rose-600 hover:bg-rose-700 text-white font-semibold">
              {loading ? "Entrando..." : "Entrar"}
            </Button>
          </form>
        </Card>
      </div>
    </div>
  );
}
